/**
 * Splits filter options into the ones pinned above the divider and the rest, keeping each list in its own order.
 * `fixed` options always lead (English and Spanish); then any option whose value is in `pinned` (the customer's
 * onboarding apps, and whatever was ticked when the list opened).
 */
export default function splitPinned<T extends { value: string }>(
  options: T[],
  pinned: string[],
  fixed: T[] = []
): { top: T[]; rest: T[] } {
  const fixedValues = new Set(fixed.map((o) => o.value));
  const want = new Set(pinned);
  const moved = options.filter((o) => want.has(o.value) && !fixedValues.has(o.value));
  const movedValues = new Set(moved.map((o) => o.value));
  return {
    top: [...fixed, ...moved],
    rest: options.filter((o) => !movedValues.has(o.value) && !fixedValues.has(o.value)),
  };
}
